import React from 'react';
import { Loader } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { states } from '@/constants/lifecycle';
import TabChangeContainer from './TabChangeContainer';

const PanelContainer = ({
  canAccess,
  children,
  description,
  entity,
  exists,
  isDirty,
  isNew,
  name,
  onChange,
  readErrors,
  readStatus = [],
  url,
}) => {
  if (readStatus.some((r) => (r === states.PENDING)) && !isNew) {
    return (
      <Loader active className="aridhia-panel-container-loader">
        <FormattedMessage id={`${entity}.loading`} />
      </Loader>
    );
  }

  return (
    <TabChangeContainer
      canAccess={canAccess}
      description={description}
      entity={entity}
      exists={exists}
      isDirty={isDirty}
      name={name}
      onChange={onChange}
      readErrors={readErrors}
      url={url}
    >
      { children }
    </TabChangeContainer>
  );
};

export default PanelContainer;
